import * as Yup from 'yup'

import { EMPTY_LIST } from '../../../constants/common'
import { toCategorySelectItem } from '../../Category'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
  isRemoveAllEntityActionType,
} from '../../Entity'
import { formValidationSchemaNoChanged } from '../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'

import {
  REQUEST_EDIT_CATEGORY_FORM_CATEGORY_FIELD,
  REQUEST_EDIT_CATEGORY_FORM_INITIAL_VALUES,
} from './RequestEditCategoryModal.constants'

export function getRequestEditCategoryModalValidationSchema({
  initialValues,
  itemAction,
}) {
  return Yup.object({
    [REQUEST_EDIT_CATEGORY_FORM_CATEGORY_FIELD]: Yup.object()
      .nullable()
      .when(FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME, {
        is: actionType =>
          !isRemoveAllEntityActionType(actionType) && !itemAction,
        then: schema => schema.required(true),
      }),
  }).when(EMPTY_LIST, {
    is: () => itemAction,
    then: schema =>
      schema.concat(formValidationSchemaNoChanged({ initialValues })),
  })
}

export function getRequestEditCategoryModalInitialValues(value) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...REQUEST_EDIT_CATEGORY_FORM_INITIAL_VALUES,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
    [REQUEST_EDIT_CATEGORY_FORM_CATEGORY_FIELD]: value
      ? toCategorySelectItem(value)
      : null,
  }
}

export function isFormFieldsEqual({ initialValues, values }) {
  return (
    initialValues[REQUEST_EDIT_CATEGORY_FORM_CATEGORY_FIELD]?.value ===
    values[REQUEST_EDIT_CATEGORY_FORM_CATEGORY_FIELD]?.value
  )
}

export function getRequestEditCategoryModalPayload(values) {
  const payload = values[REQUEST_EDIT_CATEGORY_FORM_CATEGORY_FIELD]?.value
    ? {
        id: values[REQUEST_EDIT_CATEGORY_FORM_CATEGORY_FIELD].value,
      }
    : null

  return payload
}
